export default __webpack_public_path__ + "static/media/packaging-desktop@2x.c9ca6479.jpg";